<template>
	<div class="pd-20-16 box-s">
     <van-list
			v-model="loading"
			:finished="finished"
			:finished-text="finishedtext"
			@load="initData"
		>
			<div class="list_every pd-16-18 box-s mb-16" :class="{ 'pra_every': index == list.length - 1}" v-for="(item, index) in list" :key="index">
        <div class="flexs flex-jus">
					<div class="flexs">
            <img class="wh_46 b-radius-50 mr-10" src="../../assets/img/icon/imitate_icon.png" alt="">

						<div class="fw-500 fz-16 c1 w157 text-hide">{{item.practice_exam_title}}</div>
					</div>
					<div class="flexs bg_ec whl-74-24 flex-center fw-500 fz-12 b-radius-12 c0" @click="lookPractice(item.id)"> 
						答题报告
						<img class="wh_4_6 ml-5" src="../../assets/img/icon/blue_right_arrow.png" alt="">
					</div>
				</div>

				<div class="flexs fw-500 fz-14 c1 pd-16 box-s bg_f9 b-radius-6 mtb-16">
					<div class="flex1">题目数量： {{item.question_num}}题</div>
					<div class="flex1">总分： {{item.total_score}}分</div>
				</div>

				<div class="flex1 pl-14 box-s">
          <div class="mb-14 fz-12 c1">练习时间</div>
          <div class="fz-14 c3">{{item.start_time}}</div>
        </div>
			</div>
		</van-list>
		<noData v-if="show"></noData>
		<loading :loadFlag="loadFlag"></loading>
	</div>
</template>
<script>

	import { practiceExamUserAnswerList } from '@/api/api'
	import { formatTime, getList } from '@/utils/common'
	import loading from "@/components/loading"
	import noData from "@/components/noData"
	export default {
		components: {
			loading,
			noData
		},
		data() {
			return {
			  list: [],
        show: false,
				loadFlag: false,
				loading:false,
				finishedtext: '',
				finished: false,
				page: 1
			};
		},
		created() {
			if(this.$route.query.flag){
        document.title = '我的模拟考试'
			} else{
				document.title = '我的练习'
			}
		},
		mounted(){
		},
		methods: {
      initData(){
				const subject_id = this.$route.query.subject_id?this.$route.query.subject_id:0
				getList(this, practiceExamUserAnswerList,  { subject_id, page: this.page  } )
			},

			lookPractice(id){
				this.$router.push({ path: '/imitreport', query: { practice_exam_user_id: id } })
			}

		}
	};
</script>
<style lang="less" scoped>

.orange_sty {
	background: #FFF4EA;
	color: #FFAB5A;
}

.cf {
	color: #497CFF !important;
	box-shadow: 0px 2px 4px 0px rgba(255, 255, 255, 1);
}

.pra_every {
	margin-bottom: 0 !important;
}
/deep/.van-list__finished-text {
	padding-top: 12px;
  line-height: 14px;
}
/deep/.van-list__loading {
	display: none;
}
</style>
